// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".position-relative[data-v-0bafb5fa]{position:relative}.position-absolute[data-v-0bafb5fa]{position:absolute}", ""]);
// Exports
module.exports = exports;
